/* eslint-disabled */
import BranchCategory from "./BranchCategory";
import ItemType from "./ItemType";
import Contract from "./Contract";
import PackCategory from "./PackCategory";
import Guarantee from "./Guarantee";
import PremiumDetailModel from "./PremiumDetailModel";
import Engine from "./Engine";
import Voucher from "./Voucher";
import CommissionModel from "./CommissionModel";
import ReductionModel from "./ReductionModel";
import AvenantType from "./AvenantType";
import BranchExtend from "@/entity/extends/BranchExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Branch extends BranchExtend {

public id!: number;
public label = '';
public icon = '';
public slug = '';
public description? = '';
public category!: BranchCategory;
public items: Array<ItemType> = [];
public ranking?: number;
public active?: boolean;
public contracts: Array<Contract> = [];
public packCategories: Array<PackCategory> = [];
public color? = '';
public guarantees: Array<Guarantee> = [];
public premiumDetailModels: Array<PremiumDetailModel> = [];
public engines: Array<Engine> = [];
public version?: number;
public vouchers: Array<Voucher> = [];
public startDate? = '';
public orderText? = '';
public illustration? = '';
public commissionModels: Array<CommissionModel> = [];
public reductionModels: Array<ReductionModel> = [];
public allowOrder?: boolean;
public avenantTypes: Array<AvenantType> = [];
public itemType!: ItemType;
public deletedAt?: Date;
public uuid? = '';
public createdAt?: Date;
public updatedAt?: Date;
public createBy? = '';
public updateBy? = '';
public removeBy? = '';
public createdFromIp? = '';
public updatedFromIp? = '';
public printables= [];
public photo? = '';
public alt? = '';

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.label= object.label;
       this.icon= object.icon;
       this.slug= object.slug;
       this.description= object.description;
this.category = (object.category instanceof BranchCategory) ? object.category : object.category ? new BranchCategory(object.category) : object.category;
       hydrateCollection(object.items, ItemType, this.items);
       this.ranking= object.ranking;
       this.active= object.active;
       hydrateCollection(object.contracts, Contract, this.contracts);
       hydrateCollection(object.packCategories, PackCategory, this.packCategories);
       this.color= object.color;
       hydrateCollection(object.guarantees, Guarantee, this.guarantees);
       hydrateCollection(object.premiumDetailModels, PremiumDetailModel, this.premiumDetailModels);
       hydrateCollection(object.engines, Engine, this.engines);
       this.version= object.version;
       hydrateCollection(object.vouchers, Voucher, this.vouchers);
       this.startDate= object.startDate;
       this.orderText= object.orderText;
       this.illustration= object.illustration;
       hydrateCollection(object.commissionModels, CommissionModel, this.commissionModels);
       hydrateCollection(object.reductionModels, ReductionModel, this.reductionModels);
       this.allowOrder= object.allowOrder;
       hydrateCollection(object.avenantTypes, AvenantType, this.avenantTypes);
this.itemType = (object.itemType instanceof ItemType) ? object.itemType : object.itemType ? new ItemType(object.itemType) : object.itemType;
       if(object.deletedAt){
           this.deletedAt= new Date(object.deletedAt);
       }
       this.uuid= object.uuid;
       if(object.createdAt){
           this.createdAt= new Date(object.createdAt);
       }
       if(object.updatedAt){
           this.updatedAt= new Date(object.updatedAt);
       }
       this.createBy= object.createBy;
       this.updateBy= object.updateBy;
       this.removeBy= object.removeBy;
       this.createdFromIp= object.createdFromIp;
       this.updatedFromIp= object.updatedFromIp;
       this.printables= object.printables;
       this.photo= object.photo;
       this.alt= object.alt;
      }
      this.postConstruct()
  }

}
